import React from 'react'
import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router-dom'

import JobsListScene from './scenes/JobsListScene'
import JobDetailsScene from './scenes/JobDetailsScene'
import JobNotFoundScene from './scenes/JobNotFoundScene'

const JobsMain = ({ match }) => {
  return (
    <Switch>
      <Route exact path={`${match.path}/:jobId`} render={() => <JobDetailsScene />} />
      <Route exact path={match.path} render={() => <JobsListScene />} />
      <Route component={JobNotFoundScene} />
    </Switch>
  )
}

JobsMain.propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string,
    params: PropTypes.shape({ candidateSlug: PropTypes.string }),
  }),
}

export default JobsMain
